import { fetch } from "domain-task";
import { toast } from "react-toastify";
import LocalizedStrings from "react-localization";
import appSettings from "../AppSettings";
import { store } from "../boot-client";
import { handlCustomException } from "./CustomErrors";
import userManager from "../helpers/UserManager";
import axios from "axios";

const strings = new LocalizedStrings({
    en: {
        errorDevNotified: "An unexpected error occured. Developers have been notified",
        apiDown: "SKALINK API unavailable"
    }
});

export function request(url, options) {
    return new Promise((resolve, reject) => {
        fetch(url, options)
            .then((response) => {
                return parseJSON(response, url, options);
            }
            )
            .then((response) => {
                if (response.ok) {
                    //console.log(response.json);
                    if (response.json.isSuccess) {
                        return resolve(response.json.result);
                    }
                }

                // Fetch succeeded but status code error (ex: 400, 401...)
                reportError(url, options, response, response.status, response.json);
                // extract the error from the server's json
                return reject({
                    status: response.status,
                    body: response.json
                });
            })
            .catch((error) => {
                // Fetch error (ex: api unavailable, error 500)
                reportError(url, options, error, "Possibly 500");
                // console.log("error request", error);
                return reject({
                    networkError: error.message
                });
            });
    });
}



export async function requestAuth(url, options = {}, signinState) {
    const user = await userManager.getUser();

    // Mode A: si pas connecté / token expiré => redirection login
    if (!user || user.expired || !user.access_token) {
        await userManager.signinRedirect({
            state: signinState ?? window.location.pathname + window.location.search
        });
        // la page va être quittée; on stoppe ici
        throw new Error("Redirecting to login");
    }

    const mergedOptions = {
        ...options,
        headers: {
            ...options.headers || {},
            Authorization: `Bearer ${user.access_token}`
        }
    };

    return request(url, mergedOptions);
}



export async function axiosAuth(url, options = {}, signinState) {
    const user = await userManager.getUser();

    // Mode A: si pas connecté / token expiré => redirection login
    if (!user || user.expired || !user.access_token) {
        await userManager.signinRedirect({
            state: signinState ?? window.location.pathname + window.location.search
        });

        // la page va être quittée; on stoppe ici
        throw new Error("Redirecting to login");
    }

    // Fusion options + headers (comme ton mergedOptions)
    const mergedOptions = {
        ...options,
        headers: {
            ...(options.headers || {}),
            Authorization: `Bearer ${user.access_token}`
        }
    };

    // Axios: soit options.method + options.data, soit helpers (get/post/put)
    return axios({
        url,
        ...mergedOptions
    });
}



function parseJSON(response, url, options) {
    return new Promise((resolve, reject) => {
        /*
            Clone response because when can only read it once
            Read it first as text to check if it is empty because json will throw a exception
            then read as json if not empty
        */
        const clone = response.clone();
        clone.text()
            .then(text => {
                if (text === "") {
                    return resolve({
                        status: response.status,
                        ok: response.ok,
                        json: text
                    });
                }
                else {
                    response.json()
                        .then((json) => {
                            return resolve({
                                status: response.status,
                                ok: response.ok,
                                json
                            });
                        })
                        .catch(error => {
                            // Error code, notify api
                            reportError(url, options, error, response.status);

                            return resolve({
                                status: response.status,
                                ok: response.ok,
                                json: {
                                    message: "unhandled exception"
                                }
                            });
                        });
                }
            });
    }
    );
}

// handle server error
export async function reportError(url, options, exception, status, body) {
    console.log(exception);
    if (body && body.isSuccess === false) {
        //handle custom exception
        handlCustomException(body.errorCode);
    }
    else if (exception && exception.message === "Failed to fetch") {
        toast.error(strings.apiDown);
    }
    else {
        toast.error(strings.errorDevNotified);
    }

    const localStorageObj = Object.assign({}, localStorage);
    // Duplicate navigator object to be able to serialize it
    const _navigator = {};
    for (const i in navigator) {_navigator[i] = navigator[i];}

    const obj = {
        apiUrl: url,
        options: JSON.stringify(options),
        status: status ? status.toString() : null,
        exception: JSON.stringify(exception),
        body: JSON.stringify(body),
        localStorage: JSON.stringify(localStorageObj),
        navigator: JSON.stringify(_navigator),
        source: "FetchApi"
    };

    const user = await userManager.getUser();

    if (!user || user.expired || !user.access_token) {
        await userManager.signinRedirect({
            state: signinState ?? window.location.pathname + window.location.search
        });
        // la page va être quittée; on stoppe ici
        throw new Error("Redirecting to login");
    }

    fetch(appSettings.SKALINKAPIURL + "/api/ErrorReport",
        {
            headers: {
                "Authorization": "Bearer " + user.access_token,
                "Content-Type": "application/json"
            },
            method: "POST",
            body: JSON.stringify(obj)
        })
        .then((response) => {
            console.log("error report successfully sent");
        })
        .catch((error) => {
            console.log("error sending error report ¯\\_(ツ)_/¯");
        });
}
